import { useState } from 'react';
const useBoolean = (initialValue = false) => {
    const [isOpen, setIsOpen] = useState(initialValue);
    const setTrue = () => {
        setIsOpen(true);
    };
    const setFalse = () => {
        setIsOpen(false);
    };
    const toggle = () => {
        setIsOpen((prev) => !prev);
    };
    return [isOpen, { setTrue, setFalse, toggle }];
};
export default useBoolean;
